// Версия, которую показываем в настройках мобильного приложения.
//
// Приоритет: текущий OTA-бандл Capgo (то, что реально крутится в WebView),
// иначе нативная versionName / CFBundleShortVersionString. На web-сборке
// ничего не читаем — подпись только в Capacitor.

import { getCapacitorPlugin } from "@studyhub/platform/lib/capacitor-plugin";
import { IS_CAPACITOR } from "@/lib/platform-detect";

interface CapacitorUpdaterCurrentShape {
	current(): Promise<{
		bundle?: { id?: string; version?: string };
		native?: string;
	}>;
}

interface AppInfoShape {
	getInfo(): Promise<{ version?: string }>;
}

/** Semver или усечённый native (`1.0` / `1.1.0`), без литерала `builtin`. */
const VERSION_RE = /^\d+\.\d+(?:\.\d+)?(?:[-+][0-9A-Za-z.-]+)?$/;

export function pickDisplayAppVersion(input: {
	bundleId?: string | null;
	bundleVersion?: string | null;
	nativeVersion?: string | null;
}): string | null {
	const bundle = input.bundleVersion?.trim() || null;
	const native = input.nativeVersion?.trim() || null;
	if (input.bundleId !== "builtin" && bundle && bundle !== "builtin" && VERSION_RE.test(bundle)) {
		return bundle;
	}
	if (native && native !== "builtin" && VERSION_RE.test(native)) return native;
	return null;
}

export async function readNativeAppVersion(): Promise<string | null> {
	if (!IS_CAPACITOR) return null;

	const updater = getCapacitorPlugin<CapacitorUpdaterCurrentShape>("CapacitorUpdater");
	const app = getCapacitorPlugin<AppInfoShape>("App");

	let bundleId: string | null = null;
	let bundleVersion: string | null = null;
	let nativeVersion: string | null = null;

	if (updater) {
		try {
			const current = await updater.current();
			bundleId = current.bundle?.id ?? null;
			bundleVersion = current.bundle?.version ?? null;
			nativeVersion = current.native ?? null;
		} catch {
			// Плагин есть, но current() не ответил — ниже спросим App.getInfo.
		}
	}

	if (!nativeVersion && app) {
		try {
			nativeVersion = (await app.getInfo()).version ?? null;
		} catch {
			nativeVersion = null;
		}
	}

	return pickDisplayAppVersion({ bundleId, bundleVersion, nativeVersion });
}
